<template>
    <div>
        <!-- 头部 -->
        <Header class="nav-menu"></Header>
        <!-- 中部 -->
        <router-view/>
        <!-- 尾部 -->
        <Footer class="footer"></Footer>
    </div>
</template>

<script>
import Header from '@/components/front/common/Header';
import Footer from '@/components/front/common/Footer';

export default {
    data() {
        return {
            
        };
    },
    components: {
        Header,
        Footer
    },
    methods: {
        
    }
}
</script>

<style scoped>
  .nav-menu {
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.05);
  }
  .footer {
    margin-top: 20px;
    line-height:30px;
    padding-bottom: 0px;
    background-image: linear-gradient(to right, #ff5db3 0%, #1d95eb 100%);
  }
</style>
  


// WEBPACK FOOTER //
// src/components/front/Main.vue